<template>
  <div>
      <el-radio-group v-model="radio"  size="mini" @change="to_change">
     <el-radio-button label="1">地图显示</el-radio-button>
      <el-radio-button label="2">日历显示</el-radio-button>
  </el-radio-group>
            <el-row :gutter="15" :style="{ display: calVisible}" style="margin-top:10px; ">
      <el-col>
          <el-card class="card"
              
              style="
                height: 200px;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 10px;
              ">
              <el-col>
                  <el-row>
                  <div>
                    <el-col :span="16" class="tatistic-title">值班信息</el-col>
                  </div>
                </el-row>
              </el-col>
              <el-descriptions  :column="3" size="size" border style="margin-top:50px;">
    
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-user"></i>
        员工姓名
      </template>
      {{paramId.accountName}}
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-time"></i>
        上班时间
      </template>
      {{paramId.startTime}}
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-time"></i>
        下班时间
      </template>
      {{paramId.endTime}}
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="
el-icon-discount"></i>
        所在组织
      </template>
      <el-tag size="small">{{paramId.orgName}}</el-tag>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-chat-dot-round"></i>
        工作内容
      </template>
      {{paramId.accountName}}{{day}}打卡{{pointCount}}次，
      处理故障{{fauCount}}个，执行巡检任务{{insCount}}次，执行任务{{taskCount}}个，执行保养任务{{maintainCount}}个
    </el-descriptions-item>
  </el-descriptions>
              </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15" :style="{ display: calVisible}" style="margin-top:20px; ">
      <el-col>
          <el-card class="card"
              style="
                height: calc(100vh - 380px);
                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 10px;
              ">
              <el-col>
                  <el-row>
                  <div>
                    <el-col :span="16" class="tatistic-title">工作日志</el-col>
                  </div>
                </el-row>
                <el-row style="margin-top:20px; ">
                  <el-col>
              <div style=" margin-left: -90px;height: calc(100vh - 480px);
  overflow-x: auto; 
    font-size: 8px;
    color: #606266;
    ">
<div v-for="(logrow, i) in  logs " :key="i" class="wrap-row">
        <div :class="{ 'row': true, 'reserve': i % 2 === 1 }">
          <ul v-for="(log, index) in  logrow " :key="index" class="item"
            :style="{ visibility: log.hidden ? 'hidden' : 'visible' }">
            <li class="title"> <span class="circle" @click="open_tab(log)">{{ log.serial }}</span>
              <span class="name">{{ log.stepname }}</span>
              <i class="line"></i>
            </li>
            <li class="description">
              <span>{{ log.location }}</span>
              <span>{{ log.time }} {{ log.name }}</span>
            </li>
            <li :class="{ 'vertcil-line': true, show: isShowVerticleLine(i + 1, index + 1) }">
              <i></i>
            </li>
          </ul>
        </div>
      </div>
              </div>
          
                  </el-col>
                </el-row>
              </el-col>
              </el-card>
      </el-col>
    </el-row>
    <div :style="{ display: mapVisible, }" style="margin-top:10px;"> 
      <div class="card-class" id="containercal1"></div>
      <!--<el-button type="success" class="map_button" icon="el-icon-back" @click="go_backCalendar">日历显示</el-button>-->
    </div>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'

export default {
  name: 'rosteringnowduty',
  props: ["funcs","paramId"],
  data () {
    return {
      loading: false,
      saving: false,
      mainVisible: "",
      calVisible: "",
      mapVisible: "none",
      queryuser: [],
      personlist: [],
      currentdata: new Date(),
      singleposVisible: false,
      posinfo: [],
      radio: "2",
      visible: false,
      i: '',
      mapData: {},
      day: '',
      fauCount: 0,
      pointCount: 0,
      insCount: 0,
      taskCount: 0,
      maintainCount: 0,
      logs: [],
    }
  },
  computed: {
        //判断竖线展示
        isShowVerticleLine() {
          return function (row, column) {
            if (row % 2 === 0) {
              if (column == 1) {
                return true
              }
            } else {
              if (column % 4 == 0) {
                return true
              }
            }
            return false
          }
        },
      },
  methods: {
    _next() {
      // this.active = Math.floor(Math.random() * 10)
      if (this.active + 2 > this.stepData.length) {
        this.active = 0;
      } else {
        this.active++;
      }
    },
    //页面初始化
    init () {
      this.displayCalendar(this.paramId)
    },
    formatData(data, count) {
          let arr = []
          let flag = false
          let rows = Math.ceil(data.length / count)
          for (let index = 0; index < rows; index++) {
            let temp = data.splice(0, count)
            if (temp.length < count) {
              if (arr.length % 2 === 1) {
                let num = count - temp.length
                while (num) {
                  temp.push({ hidden: true })
                  num--
                }
              }
            }
            if (flag) {
              temp.reverse()
              flag = !flag
            } else {
              flag = !flag
            }
            arr.push(temp)
          }
          return arr
        },
 //显示日历信息
    displayCalendar (row) {
      
      const day = this.$moment(row.dutyTime).format('YYYY-MM-DD');
      this.day=day
      this.mainVisible = "none"
      this.calVisible = ""
      this.mapVisible = "none"
      this.visible=true
      this.currentdata = new Date(row.startTime.replace(/-/g, "/"));
      console.log(this.currentdata)
      this.queryuser = { accountId: row.accountId, dutyTimeDay: this.currentdata }
      this.getpointClockbyperson()
    },
    getpointClockbyperson () {
      this.loading = true
      this.$ajax.get('/buss/rostering/listRosteringPlanDetailByDay', this.queryuser).then(msg => {
        console.log(msg)
        this.mapData.mapPointData=msg.mapPointData
        this.mapData.mapFauData=msg.mapFauData
        this.mapData.mapInsData=msg.mapInsData
        this.mapData.mapMaintainData=msg.mapMaintainData
        this.mapData.mapTaskData=msg.mapTaskData
        this.logs = this.formatData(msg.workLogData, 4)
        this.pointCount=msg.mapPointData.length
        this.fauCount=msg.mapFauData.length
        this.insCount=msg.mapInsData.length
        this.maintainCount=msg.mapMaintainData.length
        this.taskCount=msg.mapTaskData.length
        console.log("daka" + this.mapData)
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    loadMonthTrackMap () {
      AMapLoader.load({
        key: '204899ccad5874a75849e637df77e6ff',
        version: '2.0',
      }).then((AMap) => {
         var infoWindow = new AMap.InfoWindow({
          offset: new AMap.Pixel(0, -30),
        });
        var map = new AMap.Map("containercal1", {  //设置地图容器id
          viewMode: "3D",    //是否为3D地图模式
          zoom: 7,           //初始化地图级别
          //center: [this.mapData.mapPointData[0].longitude, this.mapData.mapPointData[0].latitude], //初始化地图中心点位置
        });
        
        this.mapData.mapPointData.forEach(function(item) {
             const marker = new AMap.Marker({
            position: new AMap.LngLat(item.longitude, item.latitude),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: item.createTime,
            data: item
          }); 
        marker.content = "<div><p class='input-item'>打卡位置 :"+item.location+"</p><p class='input-item'>打卡时间 :"+item.createTime+"</p></div></div>";
        marker.on('click', markerClick);
        //marker.emit('click', {target: marker}); //默认初始化不出现信息窗体,打开初始化就出现信息窗体
          // 将创建的点标记添加到已有的地图实例：       
          map.add(marker);
        } );

        this.mapData.mapFauData.forEach(function(item) {
             const marker = new AMap.Marker({
            position: new AMap.LngLat(item.longitude, item.latitude),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: item.createTime,
            data: item
          }); 
        marker.content = "<div><p class='input-item'>打卡位置 :"+item.location+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;故障编号：<a>"+item.code+"</a></p><p class='input-item'>打卡时间 :"+item.solveTime+"</p></div></div>";
        marker.on('click', markerClick);
        //marker.emit('click', {target: marker}); //默认初始化不出现信息窗体,打开初始化就出现信息窗体
          // 将创建的点标记添加到已有的地图实例：       
          map.add(marker);
        } );

        this.mapData.mapInsData.forEach(function(item) {
             const marker = new AMap.Marker({
            position: new AMap.LngLat(item.longitude, item.latitude),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: item.createTime,
            data: item
          }); 
        marker.content = "<div><p class='input-item'>打卡位置 :"+item.location+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;巡检设备名称：<a>"+item.assetName+"</p><p class='input-item'>打卡时间 :"+item.finishTime+"</p></div></div>";
        marker.on('click', markerClick);
        //marker.emit('click', {target: marker}); //默认初始化不出现信息窗体,打开初始化就出现信息窗体
          // 将创建的点标记添加到已有的地图实例：       
          map.add(marker);
        } );

        this.mapData.mapMaintainData.forEach(function(item) {
             const marker = new AMap.Marker({
            position: new AMap.LngLat(item.longitude, item.latitude),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: item.createTime,
            data: item
          }); 
        marker.content = "<div><p class='input-item'>打卡位置 :"+item.location+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;保养设备名称：<a>"+item.assetName+"</p><p class='input-item'>打卡时间 :"+item.doneTime+"</p></div></div>";
        marker.on('click', markerClick);
        //marker.emit('click', {target: marker}); //默认初始化不出现信息窗体,打开初始化就出现信息窗体
          // 将创建的点标记添加到已有的地图实例：       
          map.add(marker);
        } );

        this.mapData.mapTaskData.forEach(function(item) {
             const marker = new AMap.Marker({
            position: new AMap.LngLat(item.longitude, item.latitude),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: item.createTime,
            data: item
          }); 
        marker.content = "<div><p class='input-item'>打卡位置 :"+item.location+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;任务名称：<a>"+item.name+"</p><p class='input-item'>打卡时间 :"+item.doneTime+"</p></div></div>";
        marker.on('click', markerClick);
        //marker.emit('click', {target: marker}); //默认初始化不出现信息窗体,打开初始化就出现信息窗体
          // 将创建的点标记添加到已有的地图实例：       
          map.add(marker);
        } );

        function markerClick(e) {
            infoWindow.setContent(e.target.content);
            infoWindow.open(map, e.target.getPosition());
        }

      }).catch(e => {
        this.$message.error(e)
      })
    },

    openSingleposform (item) {
      
      this.posinfo = item
      this.singleposVisible = true
      this.loadtimeMap(item)
    },

    loadtimeMap (item) {
      AMapLoader.load({
        key: '204899ccad5874a75849e637df77e6ff',
        version: '2.0',
      }).then((AMap) => {
        var map = new AMap.Map("singlemap", {
          viewMode: "3D",
          zoom: 13,
          center: [item.longitude, item.latitude],
        });
        var marker = new AMap.Marker({
          position: new AMap.LngLat(item.longitude, item.latitude),
          title: item.createTime
        });
        map.add(marker);
        marker.setLabel({
          direction: 'right',
          offset: new AMap.Pixel(-58, -30),
          content: item.createTime,
        })
      }).catch(e => {
        this.$message.error(e)
      })
    },
    to_change(){
      console.log(this.mapData)
      if(this.radio === "1"){
if (this.mapData != null && this.mapData.mapPointData.length>0 || this.mapData.mapFauData.length>0|| this.mapData.mapInsData.length>0||this.mapData.mapMaintainData.length>0|| this.mapData.mapTaskData.length>0) {
        this.mainVisible = "none"
        this.calVisible = "none"
        this.mapVisible = ""
        this.loadMonthTrackMap()
      }
      else {
        this.$notify({
          title: '警告',
          message: '地图上没有可以显示的打卡记录信息',
          type: 'warning'
        });
        this.radio='2'
      }
      }else{
this.mainVisible = "none"
      this.calVisible = ""
      this.mapVisible = "none"
      }
    },
    open_tab(row){
        console.log(row)
        if(row.stepname === "保养"){
          this.add_maintain_tab(row)
        }else if(row.stepname === "故障"){
          this.add_fau_tab(row)
        }else if(row.stepname === "巡检"){
this.add_ins_tab(row)
        }else if(row.stepname === "任务"){
this.add_task_tab(row)
        }else if(row.stepname === "打卡"){
          this.add_point_tab(row)
        }

    },
    add_maintain_tab(row) {
      console.log(this.$store.getUser())
      if (this.$store.getUser().menus.indexOf("/maintain/maintainquery") >= 0) {
        let param = {
        id: 92,
          label: "保养查看",
          icon: "el-icon-paibanchaxun",
          url: "/maintain/maintainquery",
        };
        if (row != null) {
          param.paramId = row.id;
        }
        this.$emit("add-tab", param);
      } else {
        this.$message.error("你没有保养查看权限");
      }
    },
    add_fau_tab(row) {
        if (this.$store.getUser().menus.indexOf("/fault/faultquery") >= 0) {
        let param = {
          id: 48,
          label: "故障查询",
          icon: "el-icon-yulanchakan",
          url: "/fault/faultquery",
        };
        if (row != null) {
          param.paramId = row.id;
        }
        this.$emit("add-tab", param);
      } else {
        this.$message.error("你没有故障查询权限");
      }
    },
    add_ins_tab(row) {
      if (this.$store.getUser().menus.indexOf("/ins/insassetquery") >= 0) {
        let param = {
          id: 52,
          label: "巡检查看",
          icon:"el-icon-jihua",
          url: "/ins/insassetquery",
        };
        if (row != null) {
          param.paramId = row.name;
        }
        this.$emit("add-tab", param);
      } else {
        this.$message.error("你没有巡检查看查看权限");
      }
    },
    add_task_tab(row) {
      if (this.$store.getUser().menus.indexOf("/task/taskquery") >= 0) {
        let param = {
         id: 72,
          label: "任务查看",
          icon: "el-icon-chaxun",
          url: "/task/taskquery",
        };
        if (row != null) {
          param.paramId = row.id;
        }
        this.$emit("add-tab", param);
      } else {
        this.$message.error("你没有任务查看权限");
      }
    },

    add_point_tab(row) {
      if (this.$store.getUser().menus.indexOf("/statistic/personpoint") >= 0) {
        let param = {
         id: 102,
          label: "打卡记录",
          icon: "el-icon-xiugai",
          url: "/statistic/personpoint",
        };
        if (row != null) {
          param.paramId = row.id;
        }
        this.$emit("add-tab", param);
      } else {
        this.$message.error("你没有任务查看权限");
      }
    },
  },
   watch: {
    
  },
  mounted () {
    console.log(this.paramId)
    this.init()
  }
}
</script>
<style scoped>
.map_button {
  position: absolute;
  top: calc(50vh + 12px);
  right: 10px;
  padding: 0px;
  height: 40px;
  opacity: 0.8;

}

.back_button {
  position: absolute;
  top: calc(50vh + 72px);
  right: 10px;
  padding: 0px;
  height: 40px;
  opacity: 0.8;
}

.card-class {
  height: calc(100vh - 115px);
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

.drawtitle {
  height: calc(100vh - 600px);
}

.drawmap {
 height: calc(100vh - 340px);
}
.tatistic-title {
  color: #74798C;
  font-size: 17px;
  margin-top: 0px;
}



 header {
    line-height: 1.5;
    height: 120px;
    width: 100%;
  }

  main {
    background-color: white;
    margin-bottom: 10px;
  }

  .content-title {
    padding: 20px;
    font-size: 20px;
    font-weight: bold;
  }

  .content {
    display: flex;
    flex-direction: column;

  }

  .row {
    display: grid;
    justify-content: space-between;
    grid-template-columns: repeat(4, 450px);
  }


  .item {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    list-style: none;
  }

  .title {
    display: flex;
    align-items: center;
  }

  .name {
    font-weight: bold;
  }

  .circle {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #babcbe;
    color: #babcbe;
    border-radius: 15px;
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  .line {
    position: absolute;
    display: inline-block;
    width: 300px;
    height: 1px;
    background-color: #babcbe;
    right: -170px;
  }

  .description {
    display: flex;
    margin-top: 5px;
    flex-direction: column;
  }

  .vertcil-line {
    height: 60px;
    width: 100%;
    display: block;
  }

  .vertcil-line.show {
    width: 1px;
    background-color: #babcbe;
  }


  .wrap-row:last-child .row .item .vertcil-line {
    display: none;
    height: 0;

  }


  .item:nth-of-type(4n) .line,
  .item:last-child .line {
    display: none;
  }
</style>
